import { Component, OnInit, OnDestroy } from '@angular/core';
import { RootScopeService } from '../../core/shared-service/root-scope.service';
import { RootScopeDeclare } from '../../core/rootscope-declare';
import { PackagePricing } from '../helpers/package-pricing';
import { CommonUtil } from '../../core/Utils/common-util';
import { environment } from '../../../environments/environment';
import { SubscriptionService } from '../services/subscription.service';
import { FacilityService } from 'src/app/core/services/facility.service';
import { FacilityObject } from 'src/app/core/services/facility.model';
import { Subscription } from 'rxjs';

declare var $: any;
@Component({
  selector: 'app-door-banner',
  templateUrl: './door-banner.component.html',
  styleUrls: ['./door-banner.component.css'],
})
export class DoorBannerComponent implements OnInit {
  rootScopeData: RootScopeDeclare;

  // subscriptions
  private _facilityOnChange: Subscription;

  expandDoorBanner = false;
  isCountryIdentified = false;
  countryID: string;
  cloudBasePath: string;
  pricingObj: any;
  upgradeURL: string;
  manageSubscriptionURL: string;
  isDoorBannerClosed = false;
  currentFacility: FacilityObject;

  
  constructor(
    private rootScopeService: RootScopeService,
    private packagePricing: PackagePricing,
    private commonUtil: CommonUtil,
    private _subscriptionService: SubscriptionService,
    private _facilityService: FacilityService
  ) {
  }

  ngOnInit() {    
    this.getRootScopeData();
    this.cloudBasePath = environment.cloudBasePath;

    // firsttime
    if (localStorage.getItem('isDoorBannerClosed') === 'true') {
      this.closeDoorBannerPopup();
    }

    this.currentFacility = this._facilityService.selectedFacility();
    this._facilityOnChange = this._facilityService.selectedFacilitySource.subscribe(res => {
      this.currentFacility = res;
    });
  }

  ngOnDestroy() {
    // destroy subscriber
    if (this._facilityOnChange) {
      this._facilityOnChange.unsubscribe();
    }
  }

  getRootScopeData(): void {
    this.rootScopeService.getRootScope().subscribe(rootScopeData => (this.rootScopeData = rootScopeData));
  }

  showDoorBannerPopup() {
    this.expandDoorBanner = true;
    $('html, body').addClass('autoScroll');
    if (!this.isCountryIdentified) {
      //this.setOptinData();
      this.countryID = this.currentFacility.summary.countryId;
      //this.pricingObj =this.packagePricing.pricing.get(this.countryID)['coremonthlyPrice'];
      this.pricingObj = this.packagePricing.pricing.get(this.countryID);
    }
    this._subscriptionService.getToken();
  }

  getPrice(module: string): void {
    let categoryVal = this.commonUtil.capitalizeWord(this.rootScopeData.pageName);
    let actionVal = this.commonUtil.capitalizeWord(module);
    $('body').removeClass('autoScroll');
    window.location.href = 'app.html#/shop/' + module;
  }

  isAlreadyOptedIn(plan: string): boolean {
    var staffPermData = this.currentFacility.summary.staffPermissionData;
    if (
      (plan === 'core' && staffPermData.coreOptedIn === 'true') ||
      (plan === 'train' && staffPermData.trainOptedIn === 'true') ||
      (plan === 'engage' && staffPermData.engageOptedIn == 'true') ||
      (plan == 'custom' && staffPermData.customAppOptedIn === 'true') ||
      (plan === 'retain' && staffPermData.membersRetentionOptedIn === 'true') ||
      (plan == 'jobTracker' && staffPermData.jobTrackerOptedIn == 'true') ||
      (plan == 'pro' && staffPermData.proOptedIn == 'true') ||
      (plan === 'haloMedia' && staffPermData.haloMediaOptedIn === 'true')
    ) {
      return true;
    }
    return false;
  }

  closeDoorBannerPopup() {
    this.expandDoorBanner = false;
    $('html, body').removeClass('autoScroll');
  }

  closeEntireDoorBanner() {
    this.rootScopeData.showDoorBanner = false;
    localStorage.setItem('isDoorBannerClosed', 'true');
    this.isDoorBannerClosed = true;
    this.closeDoorBannerPopup();
    $('.withDoorBanner').removeClass('withDoorBanner');
    window.dispatchEvent(new Event('resize'));
  }
}
